module.exports = __webpack_public_path__ + "static/media/36.d4a6e112.png";